import { render } from "./GetSectionText.vue?vue&type=template&id=7cd007ee"
import script from "./GetSectionText.vue?vue&type=script&lang=js"
export * from "./GetSectionText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/_helper/GetSectionText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cd007ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cd007ee', __exports__)) {
    api.reload('7cd007ee', __exports__)
  }
  
  module.hot.accept("./GetSectionText.vue?vue&type=template&id=7cd007ee", () => {
    api.rerender('7cd007ee', render)
  })

}


export default __exports__